export const initState = {
  articles: [],
}
